module.exports = __webpack_public_path__ + "static/img/qq.d8671f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qq.jpg
// module id = 85Bp
// module chunks = 0